// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"463":"c8e0255c","2487":"c8e0255c","2831":"c8e0255c","4096":"c8e0255c","6346":"c8e0255c","7888":"c8e0255c","9640":"0dfc1d9c"}[chunkId] + ".chunk.css";
};